import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// import * as htmlToImage from 'html-to-image';
// import download from 'downloadjs';

import GlobalStyles from './global-style';
import configureStore from './state';
import { fetchData } from './state/actions/createData';
// import { domListeners } from './state/actions/createBrowserUtils';

import FullyVaccinated from './views/fullyVaccinated';

const store = configureStore();

const element = (
  <Provider store={store}>
    <GlobalStyles />
    <div className="content-wrap">
      <FullyVaccinated />
    </div>
  </Provider>
);

ReactDOM.render(element, document.getElementById('foot'));

/* Start up functions */
// store.dispatch(domListeners());
store.dispatch(fetchData());

/* Test html-image functionalty - comment out for production IMPORTANT */
/*
console.log(
  '++++++++++++++++ COMMENT THIS OUT FOR PRODUCTION BUILD - YOU IDIOT',
);
function downloadImageFile() {
  window.removeEventListener('click', downloadImageFile);
  htmlToImage.toPng(document.getElementById('sectionTop')).then((dataUrl) => {
    download(dataUrl, 'sectionTop.png');
  });
  htmlToImage.toPng(document.getElementById('sectionBot')).then((dataUrl) => {
    download(dataUrl, 'sectionBot.png');
  });
}
window.addEventListener('click', downloadImageFile);
*/
